<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "XingbieNianlin",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object,
      default() {
        return null;
      },
      legendList: null
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.id));
      var option = {
          tooltip : {
              trigger: 'axis',
              axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                  type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
          },
          legend: {
              data:this.chartData.legendList,
              icon: "rect",
              itemGap: 40,
              itemWidth: 12,
              itemHeight: 12,
              top: 18,
              left: "center",
              textStyle: {
                  color: "#fff",
                  fontSize: 14
              }
          },
          grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          xAxis : [
              {
                  type : 'value',

                  axisTick: {
                      show: false
                  },
                  // min: -20,
                  // max: 20,
                  // splitNumber: 8,
                  splitLine: {
                      show: true,
                      lineStyle: {
                          color: "#414f5a",
                          type: "dashed"
                      }
                  },
                  axisLine: {
                      //坐标 轴线
                      show: true, //是否显示坐标轴轴线
                      lineStyle: {
                          color: "#414f5a"
                      }
                  },
                  axisLabel: {
                      textStyle: {
                          fontWeight: "bold",
                          color: "#fff",
                          fontSize: 13.5
                      }
                  }
              }
          ],
          yAxis : [
              {
                  type : 'category',
                  show: "true",
                  axisTick : {show: false},
                  data : this.chartData.nameList,

                  axisLabel: {
                      formatter: "{value}",
                      textStyle: {
                          fontWeight: "bold",
                          color: "#fff",
                          fontSize: 13.5
                      }
                  },
              }
          ],
          series : [
              {
                  name:this.chartData.legendList[0],
                  type:'bar',
                  stack: '总量',
                  label: {
                      normal: {
                          show: true,
                          position: 'left'
                      }
                  },
                  itemStyle: {
                      normal: {
                        color: '#0d81af',
                      }
                  },
                  data:this.chartData.women.layer
              },
              {
                  name:this.chartData.legendList[1],
                  type:'bar',
                  stack: '总量',
                  label: {
                      normal: {
                          show: true
                      }
                  },
                  itemStyle: {
                      normal: {
                        color: '#d25453',
                      }
                  },
                  data:this.chartData.men.layer,
              }
          ]
      };

        this.chart.setOption(option);
    }
  }
};
</script>
